import { motion, useReducedMotion } from 'framer-motion'

// Step 5 — the crash, told in each game's own language: a ball buried in the
// net (Defender), a shattered wicket (Howzzat), or an exploding rocket
// (Crash / Rocket Boom). The busted multiplier is struck through in the error colour.

const CAPTION = {
  football: 'Held on a beat too long — goal conceded.',
  cricket: 'One shot too many — clean bowled.',
  rocket: 'Pushed too far — the rocket blew.',
}

const FootballBust = () => (
  <svg viewBox="0 0 56 56" width="52" height="52" aria-hidden="true">
    <g transform="translate(6,8)" stroke="rgba(255,255,255,0.4)" fill="none">
      <rect x="0" y="0" width="44" height="30" strokeWidth="2" />
      <g stroke="rgba(255,255,255,0.2)" strokeWidth="1">
        <path d="M0,10 H44 M0,20 H44 M11,0 V30 M22,0 V30 M33,0 V30" />
      </g>
    </g>
    <circle cx="30" cy="30" r="8" fill="#ffffff" stroke="var(--htp-error)" strokeWidth="1.5" />
    <path d="M30,25.6 L34.2,28.7 L32.6,33.6 L27.4,33.6 L25.8,28.7 Z" fill="#0e151d" />
  </svg>
)

const CricketBust = () => (
  <svg viewBox="0 0 56 56" width="52" height="52" aria-hidden="true">
    {/* bails flying off */}
    <rect x="16" y="12" width="10" height="3" rx="1.5" fill="var(--htp-error)" transform="rotate(-24 21 13)" />
    <rect x="30" y="10" width="10" height="3" rx="1.5" fill="var(--htp-error)" transform="rotate(20 35 11)" />
    {/* three stumps, knocked askew */}
    <rect x="18" y="18" width="4" height="30" rx="2" fill="#d8b98c" transform="rotate(-10 20 33)" />
    <rect x="26" y="17" width="4" height="31" rx="2" fill="#d8b98c" />
    <rect x="34" y="18" width="4" height="30" rx="2" fill="#d8b98c" transform="rotate(11 36 33)" />
  </svg>
)

const RocketBust = () => (
  <svg viewBox="0 0 56 56" width="52" height="52" aria-hidden="true">
    <g transform="translate(28,28)" fill="var(--htp-error)">
      <path d="M0,-20 L4,-6 L18,-4 L6,3 L11,18 L0,9 L-11,18 L-6,3 L-18,-4 L-4,-6 Z" />
    </g>
    <circle cx="28" cy="28" r="5" fill="#ffffff" opacity="0.9" />
  </svg>
)

const GLYPHS = {
  football: FootballBust,
  cricket: CricketBust,
  rocket: RocketBust,
}

const BustVisual = ({ family }) => {
  const reduce = useReducedMotion()
  const Glyph = GLYPHS[family] ?? RocketBust

  return (
    <div className="htp-bust">
      <motion.div
        className="htp-bust-icon"
        animate={reduce ? undefined : { rotate: [0, -8, 8, -4, 0], scale: [1, 1.1, 1] }}
        transition={reduce ? undefined : { repeat: Infinity, repeatDelay: 1.4, duration: 0.6 }}
      >
        <Glyph />
      </motion.div>
      <div className="htp-bust-mult">1.87×</div>
      <span className="htp-vlabel">{CAPTION[family] ?? CAPTION.rocket}</span>
    </div>
  )
}

export default BustVisual
